//bao migrate skip
import template from "./badge2-template.html";
import { Badge2Component } from "./badge2-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new Badge2Component(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};